import React from "react";
import { Center, Image, Text, VStack } from "@chakra-ui/react";
import notificationPlaceholder from "assets/push-notifications-placeholder.png";

export const NotificationPlaceholder = () => {
  return (
    <Center height="100%">
      <VStack
        spacing={4}
        alignItems={"center"}
        justifyContent={"center"}
        height={"500px"}
      >
        <Image
          src={notificationPlaceholder}
          alt="Notification Placeholder"
          boxSize="50px"
        />
        <Text fontSize="lg" fontWeight="bold" color="gray.500">
          Select notification to view details
        </Text>
      </VStack>
    </Center>
  );
};
